import { format } from 'date-fns';
import { compact, get } from 'lodash';
import { GridActionsCellItem, GridRenderCellParams, GridRowParams } from '@mui/x-data-grid-pro';
import { Box } from '@mui/system';
import { Tooltip } from '@mui/material';
import {
  FolderOpen as FolderIcon,
  ImportExport as ImportExportIcon,
  Print as PrintIcon,
  Description as GridDetailIcon,
  Send as SendIcon,
} from '@mui/icons-material';
import { SHOW_DOCUMENT } from 'constants/constants';

export const columnsForDocumentGrid = ({ t, ...rest }: any) => {
  return [
    {
      field: 'actions',
      headerName: t('Grid:actions'),
      type: 'actions',
      hideable: false,
      width: 250,
      getActions: ({ row }: GridRowParams) =>
        rest?.emptyAction
          ? []
          : compact([
              <GridActionsCellItem
                icon={
                  <Tooltip title={t('Grid:showDocument')}>
                    <GridDetailIcon />
                  </Tooltip>
                }
                label={t('Grid:showDocument')}
                onClick={() => rest?.onEntityAction(row, SHOW_DOCUMENT)}
                showInMenu={false}
              />,
              rest.canPrintDocuments && (
                <GridActionsCellItem
                  icon={
                    <Tooltip title={t('multiplePrint')}>
                      <PrintIcon />
                    </Tooltip>
                  }
                  label={t('multiplePrint')}
                  onClick={() => rest?.onEntityAction(row, 'print_document')}
                  showInMenu={true}
                />
              ),
              rest.canPrintStandardizedDocuments && (
                <GridActionsCellItem
                  icon={
                    <Tooltip title={t('multipleStandardizedPrint')}>
                      <PrintIcon />
                    </Tooltip>
                  }
                  label={t('multipleStandardizedPrint')}
                  onClick={() => rest?.onEntityAction(row, 'standardized_print_document')}
                  showInMenu={true}
                />
              ),
              rest.canExportDocuments && (
                <GridActionsCellItem
                  icon={
                    <Tooltip title={t('multipleExport')}>
                      <ImportExportIcon />
                    </Tooltip>
                  }
                  label={t('multipleExport')}
                  onClick={() => rest?.onEntityAction(row, 'export')}
                  showInMenu={true}
                />
              ),
              rest?.canAddToFolder && (
                <GridActionsCellItem
                  icon={
                    <Tooltip title={t('multipleAddToFolder')}>
                      <FolderIcon />
                    </Tooltip>
                  }
                  label={t('multipleAddToFolder')}
                  onClick={() => rest?.onEntityAction(row, 'add_to_folder')}
                  showInMenu={true}
                />
              ),
              (rest.canSendDocumentsAsPdf ||
                rest.canSendDocumentsAsDicom ||
                rest.canSendViaEpacs ||
                rest.canSendViaRedimed ||
                rest.canSendViaMdex) && (
                <GridActionsCellItem
                  icon={
                    <Tooltip title={t('sendDocument')}>
                      <SendIcon />
                    </Tooltip>
                  }
                  label={t('sendDocument')}
                  onClick={() => rest?.onEntityAction(row, 'send')}
                  showInMenu={true}
                />
              ),
            ]),
    },
    {
      field: 'typeOfDocumentName',
      headerName: t('typeOfDocument'),
      hideable: false,
      width: 200,
      type: 'singleSelect',
      valueOptions: rest.uniqTypeOfDocumentNames || [],
      renderCell: ({ row }: GridRenderCellParams) => (
        <>
          {rest?.onEntityAction ? (
            <Tooltip title={get(row, 'typeOfDocumentName', '')}>
              <Box
                onClick={() => rest?.onEntityAction(row, SHOW_DOCUMENT)}
                sx={rest?.styles.gridLink}
              >
                {get(row, 'typeOfDocumentName', '')}
              </Box>
            </Tooltip>
          ) : (
            <Box>{get(row, 'typeOfDocumentName', '')}</Box>
          )}
        </>
      ),
    },
    {
      field: 'createdDateTime',
      headerName: t('createdDateTime'),
      type: 'date',
      renderCell: ({ row }: GridRenderCellParams) =>
        format(new Date(get(row, 'createdDateTime', '')), 'dd.MM.yyyy HH:mm:ss'),
      valueGetter: (value: any) => value && new Date(value),
    },
    { field: 'author', headerName: t('author'), width: 220 },
    { field: 'referenceID', headerName: t('referenceID') },
    { field: 'externalId', headerName: t('externalId'), width: 250 },
    {
      field: 'externalWorkplaceCode',
      headerName: t('externalWorkplaceCode'),
      renderHeader: rest?.renderHeaderWithSpinner,
    },
    {
      field: 'externalWorkplaceName',
      headerName: t('externalWorkplaceName'),
      renderHeader: rest?.renderHeaderWithSpinner,
    },
    { field: 'description', headerName: t('description') },
  ];
};
